export default "__VITE_ASSET__CXNX41FK__"